export default "__VITE_ASSET__BicNZLYB__"